import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../components/auth/AuthContext';
import { useOFEFetch } from './useOFE';

const ST = { proposed: 'text-yellow-400', approved: 'text-blue-400', executed: 'text-green-400', rejected: 'text-red-400' };

export default function OFEReallocationList() {
  const { user } = useAuth();
  const [status, setStatus] = useState('');
  const query = status ? `?status=${status}` : '';
  const { data: reallocations, loading } = useOFEFetch(`/ofe/reallocations${query}`, user, [status]);

  return (
    <div className="p-6 space-y-4">
      <div className="flex items-center gap-4">
        <h1 className="text-xl font-bold text-white">Reallocations</h1>
        <select value={status} onChange={e => setStatus(e.target.value)}
          className="ml-auto bg-gray-800 border border-gray-600 text-white px-3 py-1.5 rounded text-sm">
          <option value="">All statuses</option>
          <option value="proposed">Proposed</option>
          <option value="approved">Approved</option>
          <option value="executed">Executed</option>
          <option value="rejected">Rejected</option>
        </select>
      </div>

      {loading && <div className="text-gray-400">Loading...</div>}

      <div className="bg-gray-800 border border-gray-700 rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-900 text-gray-400">
            <tr>
              <th className="text-left px-4 py-3">Number</th>
              <th className="text-left px-4 py-3">From</th>
              <th className="text-left px-4 py-3">To</th>
              <th className="text-left px-4 py-3">Status</th>
              <th className="text-left px-4 py-3">Proposed</th>
              <th className="text-left px-4 py-3">Vendor Approval</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-700">
            {(reallocations || []).map(r => (
              <tr key={r.id} className="hover:bg-gray-750">
                <td className="px-4 py-3 font-mono text-blue-400 text-xs">{r.reallocation_number}</td>
                <td className="px-4 py-3 font-mono text-red-400 text-xs">{r.from_project}</td>
                <td className="px-4 py-3 font-mono text-green-400 text-xs">{r.to_project}</td>
                <td className="px-4 py-3"><span className={`text-sm font-semibold ${ST[r.status] || 'text-gray-300'}`}>{r.status}</span></td>
                <td className="px-4 py-3 text-gray-400 text-xs">{r.proposed_at?.slice(0, 10)}</td>
                <td className="px-4 py-3 text-xs text-gray-400">{r.vendor_approval_required ? '⚠ Required' : 'Not required'}</td>
                <td className="px-4 py-3">
                  <Link to={`/ofe/reallocations/${r.id}`} className="text-blue-400 hover:text-blue-300 text-xs">Open →</Link>
                </td>
              </tr>
            ))}
            {!reallocations?.length && !loading && (
              <tr><td colSpan={7} className="px-4 py-8 text-center text-gray-500">No reallocations</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
